import { m as moment } from '../../../moment-27179cac.js';
import '../../../_commonjsHelpers-4c2b67c2.js';

var DATE_FORMATS = {
    TABLE_SHORT: 'DD/MM/YYYY',
    TABLE_LONG: 'DD/MM/YYYY HH:mm',
    INPUT_SHORT: 'YYYY-MM-DD',
    INPUT_LONG: 'YYYY-MM-DD HH:mm',
    TIME: 'HH:mm:ss',
    CHART: 'LL HH:mm',
    CHART_II: 'll'
};
var timeFormat = function (date) {
    return moment(date).format(DATE_FORMATS.TIME);
};
var getLocaleTimeWithMoment = function (date) {
    return moment("".concat(date, "Z")).format(DATE_FORMATS.TIME);
};
var getStartEndDay = function (date) {
    var startDate = moment(date).utcOffset(0, true).startOf('day').toISOString();
    var endDate = moment(date).utcOffset(0, true).endOf('day').toISOString();
    return {
        endDate: endDate,
        startDate: startDate,
    };
};

export { DATE_FORMATS, getLocaleTimeWithMoment, getStartEndDay, timeFormat };
